/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SuccessResponse = zod
	.object({
		ok: zod.boolean().describe('Success indicator')
	})
	.describe('Generic success response');

export type SuccessResponse = zod.input<typeof SuccessResponse>;
export type SuccessResponseOutput = zod.output<typeof SuccessResponse>;
